import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Session } from "@talkjs/react";
import store, { persistor } from "./store";
import Theme from "components/template/Theme";
import Layout from "components/layout";
import history from "./history";
import mockServer from "./mock";
import appConfig from "configs/app.config";
// import { Amplify } from "aws-amplify";
import "./locales";
// import awsconfig from "./aws-exports";
import { getCookie, setCookie } from "react-use-cookie";
import { ToastContainer, Bounce } from "react-toastify";
import { onSignOutSuccess } from "store/auth/sessionSlice";
import { clearFeatures, setFeatures } from "store/auth/featureSlice";
import {
  initialState,
  setIsConnectedPartner,
  setUser,
} from "store/auth/userSlice";
import { PERSIST_STORE_NAME } from "constants/app.constant";

const FORCE_LOGOUT_WAVE = "08/24/2026"; // FLAG: change this value to force logout all users

const environment = process.env.NODE_ENV;

// Amplify.configure(awsconfig);

if (appConfig.enableMock) {
  mockServer({ environment });
}

function App() {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const userInfoCookie = getCookie("userInfo");
    if (userInfoCookie) {
      try {
        const parsedData = JSON.parse(userInfoCookie);
        if (parsedData.user?.talkJsId) {
          setUserId(parsedData.user.talkJsId);
        }
      } catch (error) {
        console.error("Error parsing user cookie:", error);
      }
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
        onBeforeLift={() => {
          const wave = localStorage.getItem("__logoutWave");
          if (wave !== FORCE_LOGOUT_WAVE) {
            localStorage.setItem("__logoutWave", FORCE_LOGOUT_WAVE);
            try {
              setCookie("userInfo", "");
              setCookie("hasSeenModal", false);
              setCookie("emailsCopied", 0);

              localStorage.removeItem(PERSIST_STORE_NAME);
              sessionStorage.clear();

              store.dispatch(setIsConnectedPartner(false));
              store.dispatch(clearFeatures());
              store.dispatch(onSignOutSuccess());
              store.dispatch(setUser(initialState));

              store.dispatch(setFeatures({ features: [] }));
              // window.location.replace(appConfig.unAuthenticatedEntryPath);
            } finally {
              // window.location.replace(appConfig.unAuthenticatedEntryPath); // backup to hard redirect to avoid redux state issues
            }
          }
        }}
      >
        <BrowserRouter history={history}>
          {userId ? (
            <Session appId={appConfig.talkJsAppId} userId={userId}>
              <Theme>
                <Layout />
              </Theme>
            </Session>
          ) : (
            <Theme>
              <Layout />
            </Theme>
          )}
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Bounce}
            limit={5}
          />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
